<template>
  <div class="c-frais-carousel">
    <div style="display: none" ref="raw">
      <slot> </slot>
    </div>
    <div
      class="c-frais-carousel__copy"
      :style="style"
      v-html="innerHTMLCopy"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'ComponentsFraisCarousel',
  props: {
    duration: { type: Number, default: 20 },
  },
  data() {
    return {
      innerHTMLCopy: '',
      style: {},
    }
  },
  mounted() {
    this.innerHTMLCopy = this.$refs.raw.innerHTML + this.$refs.raw.innerHTML
    this.style = { animationDuration: `${this.duration}s` }
  },
}
</script>

<style lang="scss" scoped>
.c-frais-carousel {
  height: 100%;
  overflow-x: hidden;
  width: 100%;

  &__copy {
    display: flex;
    width: max-content;
    animation: scroll 20s linear infinite;
  }
}

@keyframes scroll {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50%);
  }
}
</style>

<style lang="scss">
.c-frais-carousel > * {
  flex: 0 0 auto;
}
</style>
